import { attributesConditionsMatch } from 'shared-helpers/customAttributes';

import type { RequestUser, UserCustomAttribute } from 'shared-types';

interface Params {
  allowEditingUnsetValueIfEnabled?: boolean;
  allowUserPermissionForAdmin?: boolean;
  user: RequestUser;
  userCustomAttribute: UserCustomAttribute;
}

const canUserCustomAttributeBeEdited = ({
  allowEditingUnsetValueIfEnabled,
  allowUserPermissionForAdmin,
  user,
  userCustomAttribute
}: Params) => {
  if (
    user?.roles.includes('superadmin') &&
    userCustomAttribute.permissions?.edit.superadmin.value
  ) {
    return userCustomAttribute.permissions.edit.superadmin.conditions?.length
      ? attributesConditionsMatch({
          conditions:
            userCustomAttribute.permissions.edit.superadmin.conditions,
          user,
          customAttributeValues: user.customAttributes
        })
      : true;
  }

  if (
    user?.roles.includes('admin') &&
    user?.permissions?.includes('manage-users') &&
    !user.roles.includes('superadmin') &&
    userCustomAttribute.permissions?.edit.admin.value
  ) {
    return userCustomAttribute.permissions.edit.admin.conditions?.length
      ? attributesConditionsMatch({
          conditions: userCustomAttribute.permissions.edit.admin.conditions,
          user,
          customAttributeValues: user.customAttributes
        })
      : true;
  }

  if (
    (user?.roles.includes('user') || user?.roles.includes('guest')) &&
    ((!user.roles.includes('admin') && !user.roles.includes('superadmin')) ||
      allowUserPermissionForAdmin) &&
    userCustomAttribute.permissions?.edit.user.value
  ) {
    return userCustomAttribute.permissions.edit.user.conditions?.length
      ? attributesConditionsMatch({
          conditions: userCustomAttribute.permissions.edit.user.conditions,
          user,
          customAttributeValues: user.customAttributes
        })
      : true;
  }

  if (
    allowEditingUnsetValueIfEnabled &&
    userCustomAttribute.userAttributesFormSettings
      ?.alwaysAllowSettingUnsetValue &&
    (user?.roles.includes('user') || user?.roles.includes('guest')) &&
    ((!user.roles.includes('admin') && !user.roles.includes('superadmin')) ||
      allowUserPermissionForAdmin)
  ) {
    const isUnset =
      user?.customAttributes?.[userCustomAttribute.key] === undefined ||
      user?.customAttributes?.[userCustomAttribute.key] === '' ||
      (Array.isArray(user?.customAttributes?.[userCustomAttribute.key]) &&
        !(user.customAttributes?.[userCustomAttribute.key] as string[]).length);

    return isUnset;
  }

  return false;
};

export default canUserCustomAttributeBeEdited;
